import React from "react";


export const ReadOnlyCellContent = ({ cellData, fieldType, extraClassNames }) => {

    let value = cellData;

    if ( (fieldType === 'DateTimeField' || fieldType === 'DateField') && value ) {
        const datetimeValue = new Date(value);
        value = datetimeValue.toLocaleDateString("en-NZ", {
            year: 'numeric', month: '2-digit', day: '2-digit'
        })
    }

    return (
        <div className={`u-height-100 ${extraClassNames}`}>{value}</div>
    )
};
